import { LatLngLiteral } from "leaflet";

import { apiInstance } from "./baseHttp";

export const reverseGeo = ({ lat, lng }: LatLngLiteral) =>
  apiInstance.get(`/depots/addresslookup?latitude=${lat}&longitude=${lng}`);
